module.exports = __webpack_public_path__ + "static/jocke-69e288c9bac6802a2a90fcbdb0ab58df.jpg";